import React from 'react'
import SectionHeading from './SectionHeading'
import ThunderBoltIcon from '../../Icons/roofers/thunder-bolt.svg'
import AcquisitionIcon from '../../Icons/roofers/acquisition.svg'
import BookIcon from '../../Icons/roofers/book.svg'
import IntrusiveIcon from '../../Icons/roofers/intrusive.svg'

const defaultHeading = 'Turn Every Neighborhood Into New Roofing Leads'

const defaultEdges = {
    topLeft: {
        src: '/assets/roofers/neighborhood-edge-1.png',
        alt: 'Decorative postcard top-left',
    },
    bottomRight: {
        src: '/assets/roofers/neighborhood-edge-2.png',
        alt: 'Decorative postcard bottom-right',
    },
}

const defaultFeatures = [
    {
        title: 'Book More <br> Inspections',
        body: 'Mailers with strong offers drive immediate homeowner response.',
        icon: <BookIcon />,
    },
    {
        title: 'Capitalize on <br> Storm Events',
        body: 'Deploy fast campaigns within 48 hours of hail, wind, or rain events.',
        icon: <ThunderBoltIcon />,
    },
    {
        title: 'Build Neighborhood <br> Trust',
        body: 'Direct mail feels local and personal, positioning you as the go-to roofer.',
        icon: <AcquisitionIcon />,
    },
    {
        title: 'Stay Top-of-<br>Mind',
        body: 'Automated multi-touch sequences nurture homeowners into calling you first.',
        icon: <IntrusiveIcon />,
    },
]

function IconBadge({ icon }) {
    return (
        <div className="flex justify-center">
            <div className="h-14 w-14 sm:h-16 sm:w-16 rounded-full bg-white shadow-[0_8px_20px_rgba(0,0,0,0.15)] flex items-center justify-center">
                <div className="text-olm">{icon}</div>
            </div>
        </div>
    )
}

function FeatureCard({ title, body, icon }) {
    return (
        <div className="flex flex-col items-center h-full">
            <IconBadge icon={icon} />
            <div className="mt-4 w-full bg-white rounded-md px-6 py-6 text-center shadow-[0_1.39px_2.78px_0_rgba(171,190,209,0.2)] flex flex-col flex-1">
                <div
                    className="text-xl sm:text-xl font-bold text-[#4D4D4D]"
                    dangerouslySetInnerHTML={{ __html: title }}></div>
                <p className="mt-2 text-[#717171] text-base sm:text-xl">
                    {body}
                </p>
            </div>
        </div>
    )
}

export default function NeighborhoodLeads(props) {
    const heading = props?.heading || defaultHeading
    const features =
        Array.isArray(props?.features) && props.features.length
            ? props.features
            : defaultFeatures
    const edges = props?.edges || defaultEdges

    return (
        <section
            className="relative overflow-visible z-20"
            style={{
                background: 'linear-gradient(180deg, #FAFAFA 0%, #FFF8EA 100%)',
            }}>
            {/* Decorative edge images (optional) */}
            {edges?.topLeft?.src ? (
                <div className="hidden lg:block absolute top-12 left-0 z-0">
                    <img
                        src={edges.topLeft.src}
                        alt={edges.topLeft.alt || 'Decorative postcard'}
                        className="w-full h-auto drop-shadow-2xl"
                    />
                </div>
            ) : null}
            {edges?.bottomRight?.src ? (
                <div className="hidden lg:block absolute -bottom-14 right-0 z-30">
                    <img
                        src={edges.bottomRight.src}
                        alt={edges.bottomRight.alt || 'Decorative postcard'}
                        className="w-full h-auto drop-shadow-2xl"
                    />
                </div>
            ) : null}

            <div className="relative z-10 container mx-auto px-4 py-14 sm:py-16 lg:py-20">
                <div className="max-w-lg mx-auto">
                    <SectionHeading>{heading}</SectionHeading>
                </div>

                <div className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8 items-stretch justify-items-center w-10/12 mx-auto md:w-full">
                    {features.map((f, idx) => (
                        <FeatureCard key={`${f.title}-${idx}`} {...f} />
                    ))}
                </div>
            </div>
        </section>
    )
}
